export const locale = {
    lang: 'tr',
    data: {
        'USERS': {
            'TITLE': 'Gebruikers'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/i18n/nl.ts